import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"move\"><g id=\"Group\"><path id=\"Stroke 14317\" d=\"M12 1V23\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Stroke 14318\" d=\"M23 12H1\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Stroke 14320\" d=\"M9 4L12 1L15 4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Stroke 14321\" d=\"M15 20L12 23L9 20\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Stroke 14322\" d=\"M20 9L23 12L20 15\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Stroke 14324\" d=\"M4 15L1 12L4 9\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }